<template>
  <div>
    <DxDataGrid
        @initialized="saveGridInstance"
        :data-source="dataSource"
        :show-borders="true"
        :column-auto-width="true"
        :column-min-width="80"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-resizing-mode="'widget'"
        :rowAlternationEnabled="true"
        :showRowLines="true"
        :height="height"
        :remoteOperations="{ 
          filtering: true,
          sorting: true,
          groupPaging: true,
          summary: true
        }"
        :autoExpandAll="false"
        @content-ready="onContentReady">
      <DxSorting mode="multiple" />
      <DxGroupPanel :visible="true" />
      <DxGrouping :auto-expand-all="true" />
      <DxScrolling :mode="'virtual'" show-scrollbar="always" column-rendering-mode="virtual" :preload-enabled="true" />
      <DxColumnChooser :enabled="true" />
      <DxStateStoring
          :enabled="true"
          type="localStorage"
          :storage-key="storageKey"
      />
      <DxFilterRow
          :visible="true"
      />
      <DxSearchPanel
          :visible="true"
          :width="240"
          placeholder="Search..."
      />
      <DxPaging :page-size="10"/>
      <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[10, 20, 50, 100, 250]"
          :show-navigation-buttons="true"
      />
      <DxFilterPanel :visible="true" />
      <DxColumn v-if="dataFields" v-for="dataField in dataFields" :key="dataField.name"
                :data-field="dataField.name"
                :caption="dataField.caption"
                :show-in-column-chooser="dataField.visible"
                :visible="dataField.visible"
                :data-type="dataField.dataType"
                :calculate-cell-value="dataField.calculateCellValue"
                :group-index="dataField.groupIndex"
                :cell-template="dataField.cellTemplate"
      />
      <template #cell-template="{ data }">
        <CellTemplate2digits :data="data" />
      </template>
    </DxDataGrid>
    <div class="mt-5" v-if="dataGridInstance">
      {{ totalCountNum }}
      rows of {{ allElementCount }}
    </div>
  </div>
</template>

<script>
import {dataSourceMixin} from '../mixins/dataSourceMixin';
import CellTemplate2digits from "@/components/CellTemplate2digits";

export default {
  name: 'CommonTable',
  mixins: [
    dataSourceMixin
  ],
  components: { CellTemplate2digits },
  data() {
    return {
      dataGridInstance: null,
      totalCountNum: 0,
    };
  },
  props: {
    keyword: {
      type: String,
      default: null
    },
    dataFields: {
      type: Array,
      default: null
    },
  },
  async created() {
    this.getAllElementCount(this.endpoint);
  },
  async mounted() {
    this.getDataSource(this.endpoint);
  },
  computed: {
    title: function () {
      return `${capitalize(this.keyword)} Table`;
    },
    storageKey: function () {
      return `${this.keyword}-table-storage`;
    },
    endpoint: function () {
      return `api/tables/${this.keyword}`;
    },
    height: function () {
      return 'calc(100vh - 205px)';
    }
  },
  methods: {
    saveGridInstance: function(e) {
      this.dataGridInstance = e.component;
    },
    onContentReady: function (e) {
      this.totalCountNum = this.dataGridInstance.totalCount();
    },
  }
}
</script>

<style scoped>

</style>